<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Imágenes</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="tab-pane active">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
             <div class="col-md-3">
              <ResourceSearchs :routeApi="'image'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
          </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <div class="row clearfix">
            <div class="col-lg-6" v-for="imagen in resources" v-bind:key="imagen.ID">
                <div class="row image-card">
                    <div class="file-name col-lg-12 mb-3 d-flex align-items-center justify-content-between">
                      <p class="m-b-5 text-muted" style="width:80%">{{imagen.NOMBRE}}</p>
                      <div>
                        <button type="button"
                        class="btn btn-icon btn-icon-mini btn-round btn-info"
                        @click="editImage(imagen)">
                            <i class="zmdi zmdi-edit"></i>
                        </button>
                        <button type="button"
                        class="btn btn-icon btn-icon-mini btn-round btn-danger"
                        @click="deleteImage(imagen)">
                            <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-12 cardtheme">
                      <div class="file p-2 d-flex flex-row justify-content-center align-items-center" style="min-height:200px">
                        <div class="hover">
                            <a :href="getTranslation(imagen.FICHERO)" target="_blank" title="Abrir a pantalla completa">
                              <span>{{languageGlobal + ' '}}</span><i class="zmdi zmdi-loupe"></i>
                            </a>
                        </div>
                        <div class="image">
                          <img onerror="this.onerror=null;this.src='./notfound.png';" :src="getTranslation(imagen.FICHERO)"
                            alt="img" class="img-fluid" width="auto" style="max-height:200px">
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>

<!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer>
       <div class="modal-body">
         <ValidationObserver ref="formValidation">
              <form @submit="formSubmit" enctype="multipart/form-data">
                      <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                        <label for="">Nombre</label>
                        <b-form-input
                          id="NOMBRE"
                          v-model="selectedItem.NOMBRE"
                          placeholder="Nombre.."
                          aria-describedby="nombre-feedback"
                        >
                        </b-form-input>
                      <span class="validation-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <br>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                        v-model="selectedItem.MULTI_LANG"
                        id="MULTI_LANG">
                        <label class="custom-control-label" for="MULTI_LANG">Multi-idioma</label>
                      </div>
                      <br>

                      <div v-if="selectedItem.MULTI_LANG">
                        <div v-for="item in selectedItem.FICHERO" v-bind:key="item.LANGUAGE">
                          <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                            <label for="Ubicacion"> Fichero  - {{item.LANGUAGE}}:</label>
                              <b-form-file accept="image/*"
                                v-model="item.TEXTO"
                                placeholder="Seleccione una imagen o arraste aquí.."
                                drop-placeholder="Drop file here...">
                              </b-form-file>
                            <span class="validation-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div v-else>
                            <label> Fichero Único:</label>
                            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                              <b-form-file accept="image/*"
                              v-model="selectedItem.FICHERO[0].TEXTO"
                              placeholder="Seleccione una imagen o arraste aquí.."
                              drop-placeholder="Drop file here..."></b-form-file>
                             <span class="validation-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                      </div>
                       <br><br>
                          Etiquetas
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>

                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Subir Imágenes</button>
                      <a class="btn btn-default" @click="$bvModal.hide('info-modal')">Cancelar</a>
                  </div>
              </form>
        </ValidationObserver>
       </div>
    </b-modal>
   <!--Modal para Editar una Imagen-->
     <b-modal id="mdlEditarImagen" title="Editar Imagen" hide-footer>
       <div class="modal-body">
         <ValidationObserver ref="formValidation">
              <form @submit="formSubmitEditarImagen" enctype="multipart/form-data">
                    <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                      <label for="">Nombre</label>
                      <b-form-input
                        id="NOMBRE"
                        v-model="selectedItem.NOMBRE"
                        placeholder="Nombre..">
                      </b-form-input>
                       <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                      <div>
                      <br>
                      Imagen a reemplazar - Idioma {{languageGlobal}}:
                      <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                        <b-form-file accept="image/*"
                          id="FICHERO_X"
                          v-model="selectedItem.FICHERO_EDIT"
                        ></b-form-file>
                        <span class="validation-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                      </div>
                      <br>
                      <label for="Tags">Etiquetas</label>
                        <div>
                        <vue-tags-input
                          v-model="tag"
                          :tags="tags"
                          :autocomplete-items="autocompleteItems"
                          @tags-changed="update"
                        />
                      </div>
                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Editar Imagen</button>
                      <a class="btn btn-default text-white"
                      @click="$bvModal.hide('mdlEditarImagen')">Cancelar</a>
                  </div>
              </form>
          </ValidationObserver>
       </div>
    </b-modal>
</div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

/* import VueDropify from 'vue-dropify'; */
export default {
  components: {
    VueTagsInput,
    ResourceSearchs,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [searchMixin, translationMixin],
  name: 'gridImages',
  data() {
    return {
      selectedCard: -1,
      perPage: 20,
      rows: 0,
      submitted: false,
      submittedModalEdit: false,
      currentPage: 1,
      ubicacion: null,
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        MULTI_LANG: true,
        FICHERO: [],
        FICHERO_EDIT: null,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      tags: [],
      newTags: [],
      tagslist: [],
      newTags2: [],
      taglist: '',
      autocompleteItems: [],
      debounce: null,
    };
  },
  methods: {
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex;
    },
    isSelected(cardIndex) {
      return this.selectedCard === cardIndex;
    },
    editImage(imagen) {
      this.limpiar();
      this.newTags = [];
      this.selectedItem.ID = imagen.ID;
      this.selectedItem.NOMBRE = imagen.NOMBRE;
      this.$root.$emit('bv::show::modal', 'mdlEditarImagen');

      this.getExistingTags(imagen.ID);
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    async deleteImage(imagen) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar una imagen ¿Esta seguro?');
      if (confirmation) {
      /** Elimino los tags asociados */
        const url = `Tagsimagenes/deleteTags/${imagen.ID}`;
        this.axios.get(url);
        this.loading = true;
        const response = await this.axios.post('image/deleteimage', { ID: imagen.ID });
        if (response.data.status === 'success') {
          await this.getPostData();
          this.loading = false;
          this.$toasted.show('Se elimino la foto seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async formSubmitEditarImagen(e) {
      this.$refs.formValidation.validate().then((success) => {
        e.preventDefault();
        if (!success) {
          return;
        }
        this.loading = true;
        const idimagen = this.selectedItem.ID;
        const config = {
          headers: { 'content-type': 'multipart/form-data' },
        };
        const formData = new FormData();
        formData.append('ID', this.selectedItem.ID);
        formData.append('NOMBRE', this.selectedItem.NOMBRE);
        formData.append('FICHERO_EDIT', this.selectedItem.FICHERO_EDIT);
        formData.append('MULTI_LANG', this.selectedItem.MULTI_LANG);
        formData.append('LANGUAGE', this.languageGlobal);

        this.axios.post('image/editimage', formData, config)
          .then(async (response) => {
            if (response.data.status === 'success') {
              const url = `Tagsimagenes/deleteTags/${this.selectedItem.ID}`;
              const url2 = 'Tagsimagenes/saveTag';

              this.axios.get(url);
              this.newTags.forEach((a) => {
                this.axios.get(`Tags/findTagByName/${a.text}`,
                  { name: a.text }).then((resp) => {
                  if (resp.data.status === 'success') {
                    this.axios.post(url2, { id: resp.data.id, idimg: idimagen });
                  } else {
                    this.axios.post(url2, { id: a.key, idimg: idimagen });
                  }
                });
              });

              this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
              this.$root.$emit('bv::hide::modal', 'mdlEditarImagen');
              this.limpiar();
              await this.getPostData();
            } else {
              this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
            }
            this.loading = false;
          });
      });
    },
    async formSubmit(e) {
      this.$refs.formValidation.validate().then((success) => {
        e.preventDefault();
        if (!success) {
          return;
        }
        this.loading = true;
        const config = {
          headers: { 'content-type': 'multipart/form-data' },
        };
        const formData = new FormData();
        formData.append('NOMBRE', this.selectedItem.NOMBRE);
        if (this.selectedItem.MULTI_LANG) {
          formData.append('MULTI_LANG', this.selectedItem.MULTI_LANG);
        }
        const prefijo = 'FICHERO_';
        this.selectedItem.FICHERO.forEach((element) => {
          formData.append(`${prefijo + element.LANGUAGE}`, element.TEXTO);
        });
        this.axios.post('image/upload', formData, config)
          .then((response) => {
            if (response.data.status === 'success') {
              // Solo si esta creando agrego el evento
              if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
                const bc = new BroadcastChannel('new_resource_image');
                bc.postMessage({
                  ID: response.data.id,
                  NOMBRE: this.selectedItem.NOMBRE,
                  FICHERO: response.data.FICHERO,
                });
              }

              const url = `Tagsimagenes/deleteTags/${response.data.id}`;
              const url2 = 'Tagsimagenes/saveTag';

              this.axios.get(url);
              this.newTags.forEach((a) => {
                this.axios.get(`Tags/findTagByName/${a.text}`,
                  { name: a.text }).then((resp) => {
                  if (resp.data.status === 'success') {
                    this.axios.post(url2, { id: resp.data.id, idimg: response.data.id });
                  } else {
                    this.axios.post(url2, { id: a.key, idimg: response.data.id });
                  }
                });
              });

              this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
              this.$root.$emit('bv::hide::modal', this.infoModal.id);
              this.limpiar();

              // Auto close if coming from a create event
              if (this.bAutoClose) {
                window.open('', '_self').close();
              }

              this.getPostData();
            } else {
              this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
            }
            this.loading = false;
          });
      });
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.selectedItem.FICHERO = [];
      this.languages.forEach((language) => {
        this.selectedItem.FICHERO.push({
          LANGUAGE: language,
          TEXTO: null,
        });
      });
      this.infoModal.title = 'Nueva Imágen';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.submitted = false;
      this.submittedModalEdit = false;
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.FICHERO = [];
      this.selectedItem.FICHERO_EDIT = null; // FICHERO_EDIT es una variable que indica cualquier idioma. Indica la primer imagen...
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        this.loading = true;
        const response = await this.axios.post('text/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async getPostData() {
      this.loading = true;
      this.newTags = [];
      try {
        const response = await this.axios.get('image', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });

      this.loading = false;
    },
    async getExistingTags(idIMG) {
      const url = `Tagsimagenes/findByimage/${idIMG}`;
      const datos = [];

      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_image_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    // Get params Id for edit
    if (this.$route.params.id != null) {
      const response = await this.axios.get('image/getimagen', {
        params: {
          id: this.$route.params.id,
        },
      });
      this.editImage(response.data);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },

    },
  },
};
</script>
